import dynamic from "next/dynamic";

export const JobsCarousel = dynamic(() => import("./component"));
